export default {
	addCategory: 'Add a category',
	addDocument: 'Add a document',
	addSubCategory: 'Add a sub-category',
	index: 'Documents and resources',
}